import React, { useEffect, useState } from "react";
import { GetOpapLedgerTransactions } from "../../../../../Actions/LedgerActions";
import { formatAmount } from "../../../../../Util";
import { FaPencilAlt } from "react-icons/fa";
import { Spinner } from "react-bootstrap";

// Helper function to check if bankCredit is valid (including 0, "0", "0.00")
const hasValidBankCredit = (bankCredit) => {
  if (bankCredit === null || bankCredit === undefined || bankCredit === "") return false;
  const numValue = parseFloat(bankCredit);
  return !isNaN(numValue) && numValue >= 0;
};

// Helper function to check if transaction is accumulative or reversal accumulative
const isAccumulativeTransaction = (transaction) => {
  return transaction.accumulativeRequestId || 
         transaction.categoryType?.includes("Transfer") ||
         transaction.type?.includes("Transfer");
};

// Helper function to check if transaction is debit
const isDebitTransaction = (transaction) => {
  return transaction.debit !== null && transaction.debit !== undefined;
};

const RenderUser = ({ user }) => {
  useEffect(() => {
    console.log("Rendering user: ", user);
  }, []);
  const [open, setOpen] = useState(false);
  return (
    <div className="dropdown-section mt-4">
      <div className="flex justify-content-between items-center">
        {/* {rollId === "monazam" && (
          <img
            src="/assets/editsymbol.png"
            alt="Edit Symbol"
            className="img-fluid mr-2 edit-icon"
          />
        )} */}
        <div>
          <span className="hgo-text" style={{ fontSize: "12px" }}>
            {user.name}
          </span>
        </div>
        <button
          className="bg-white text-black textSizeIcon"
          onClick={() => {
            setOpen(!open);
          }}
        >
          {open ? "-" : "+"}
        </button>
      </div>
      {open && (
        <table className="table mt-2">
          <colgroup>
            <col style={{ width: "15%" }} />
            <col style={{ width: "40%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "15%" }} />
          </colgroup>
          <tbody>
            {user.transactions.map((transaction, index) => {
              // For main transaction row in sub-ledger: balance = transaction.balance + bankCredit (if applicable and NOT debit)
              const subLedgerBalance = parseFloat(transaction.balance || 0);
              const subLedgerBankCredit = parseFloat(transaction.bankCredit || 0);
              const isDebit = isDebitTransaction(transaction);
              const mainSubLedgerBalance = !isDebit && isAccumulativeTransaction(transaction) && hasValidBankCredit(transaction.bankCredit)
                ? subLedgerBalance + subLedgerBankCredit
                : subLedgerBalance;
              
              return (
                <React.Fragment key={index}>
                  {/* First show bank charges row if applicable for OPAP (only if NOT debit) */}
                  {!isDebit && transaction.ledgerType === "opap" && isAccumulativeTransaction(transaction) && hasValidBankCredit(transaction.bankCredit) ? (
                    <tr>
                      <td className="tabledata-txt py-3">
                        {transaction.date?.split("T")[0]}
                      </td>
                      <td className="tabledata-txt py-3">Bank Charges</td>
                      <td className="tabledata-txt py-3"></td>
                      <td className="tabledata-txt py-3">
                        {formatAmount(transaction.bankCredit) || "0"}
                      </td>
                      <td className="tabledata-txt py-3">
                        {formatAmount(transaction.balance || 0)}
                      </td>
                    </tr>
                  ) : null}
                  {/* Then show main transaction row */}
                  <tr>
                    <td className="tabledata-txt py-3">
                      {transaction.date?.split("T")[0]}
                    </td>
                    <td className="tabledata-txt py-3">
                      {transaction.narration}
                    </td>
                    <td className="tabledata-txt py-3">
                      {transaction.debit !== null && transaction.debit !== undefined
                        ? formatAmount(transaction.debit)
                        : ""}
                    </td>
                    <td className="tabledata-txt py-3">
                      {transaction.debit !== null && transaction.debit !== undefined
                        ? ""
                        : transaction.credit !== null && transaction.credit !== undefined
                        ? formatAmount(transaction.credit)
                        : transaction.ledgerType === "opap"
                        ? formatAmount(transaction.creditSar)
                        : formatAmount(transaction.creditSAR)}
                    </td>
                    <td className="tabledata-txt py-3">
                      {formatAmount(mainSubLedgerBalance)}
                    </td>
                  </tr>
                  {/* Then show bank charges row if applicable for E-Hajj */}
                  {transaction.type === "ehajj" && transaction.bankCreditSAR ? (
                    <tr>
                      <td className="tabledata-txt py-3">
                        {transaction.date?.split("T")[0]}
                      </td>
                      <td className="tabledata-txt py-3">Bank Charges</td>
                      <td className="tabledata-txt py-3"></td>
                      <td className="tabledata-txt py-3">
                        {formatAmount(transaction.bankCreditSAR)}
                      </td>
                      <td className="tabledata-txt py-3">
                        {formatAmount(transaction.balance || 0)}
                      </td>
                    </tr>
                  ) : null}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

const Table = ({ setAmount, isMonazam = true }) => {
  const [users, setUsers] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchTransactions = () => {
    setLoading(true);
    GetOpapLedgerTransactions(
      setTransactions,
      setUsers,
      setAmount,
      setLoading,
      setError,
      isMonazam
    );
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px" }}
      >
        <Spinner animation="border" style={{ color: "#198754" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  else if (!!error) return <p>{error}</p>;
  else
    return (
      <div>
        <div className="table-responsive">
          <table className="table table-borderless">
            <colgroup>
              <col style={{ width: "15%" }} />
              <col style={{ width: "40%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <thead>
              <tr>
                <th className="tableheader-txt">Date</th>
                <th className="tableheader-txt">Narration</th>
                <th className="tableheader-txt">Debit</th>
                <th className="tableheader-txt">Credit</th>
                <th className="tableheader-txt">Balance</th>
              </tr>
            </thead>
            <tbody>
              {/* Combined Table: Show all transactions for both Monazam and HGO portals */}
              {transactions?.map((transaction) => {
                  // For main transaction row: balance = sarOpapLedgerAmount + bankCredit (if applicable and NOT debit)
                  const ledgerAmount = parseFloat(transaction.sarOpapLedgerAmount || 0);
                  const bankCredit = parseFloat(transaction.bankCredit || 0);
                  const isDebit = isDebitTransaction(transaction);
                  const mainTransactionBalance = !isDebit && isAccumulativeTransaction(transaction) && hasValidBankCredit(transaction.bankCredit)
                    ? ledgerAmount + bankCredit
                    : ledgerAmount;
                  
                  return (
                    <>
                      {/* First show bank charges row if applicable (only if NOT debit) */}
                      {!isDebit && transaction.ledgerType === "opap" && isAccumulativeTransaction(transaction) && hasValidBankCredit(transaction.bankCredit) ? (
                        <tr>
                          <td className="tabledata-txt">
                            {transaction.date?.split("T")[0]}
                          </td>
                          <td className="tabledata-txt">Bank Charges</td>
                          <td className="tabledata-txt"></td>
                          <td className="tabledata-txt">
                            {formatAmount(transaction.bankCredit) || "0"}
                          </td>
                          <td className="tabledata-txt">
                            {formatAmount(transaction.sarOpapLedgerAmount || 0)}
                          </td>
                        </tr>
                      ) : null}
                      {/* Then show main transaction row */}
                      <tr>
                        <td className="tabledata-txt py-3">
                          {transaction.date?.split("T")[0]}
                        </td>
                        <td className="tabledata-txt py-3">
                          {transaction.narration}
                        </td>
                        <td className="tabledata-txt py-3">
                          {transaction.debit !== null && transaction.debit !== undefined
                            ? formatAmount(transaction.debit)
                            : ""}
                        </td>
                        <td className="tabledata-txt py-3">
                          {transaction.credit !== null && transaction.credit !== undefined
                            ? formatAmount(transaction.credit)
                            : ""}
                        </td>
                        <td className="tabledata-txt py-3">
                          {formatAmount(mainTransactionBalance)}
                        </td>
                      </tr>
                    </>
                  );
                })
              }
            </tbody>
          </table>
          {/* Sub-ledgers: Show all for Monazam, only own for HGO */}
          {(() => {
            let usersToShow = [];
            
            if (isMonazam) {
              // Monazam Portal: Show all HGO sub-ledgers, filter empty ones
              usersToShow = users.filter(user => {
                return user.transactions && user.transactions.length > 0;
              });
            } else {
              // HGO Portal: Show only the logged-in HGO's sub-ledger (if it has transactions)
              if (users.length > 0 && users[0]?.transactions && users[0].transactions.length > 0) {
                usersToShow = [users[0]];
              }
            }
            
            return usersToShow.map((tuser) => {
              return (
                <React.Fragment key={tuser.id}>
                  <RenderUser user={tuser} />
                  <hr />
                </React.Fragment>
              );
            });
          })()}
        </div>
      </div>
    );
};

export default Table;